import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import WinchTypeService from "@services/WinchTypeService";

const ShowWinchType = ({ winchType }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [winchTypeData, setWinchTypeData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      WinchTypeService.find(winchType.id).then((response) => {
        setWinchTypeData(response.data.data);
      });
  }, [winchType.id, showModal]);

  return (
    <PermissionHandler permission={"view_winch_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={winchTypeData.name} />
          <RowDetails label={t("nameEng")} value={winchTypeData.name_eng} />
          <RowDetails
            label={t("description")}
            value={winchTypeData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowWinchType;
